export default "__VITE_ASSET__qd8Mdt_u__"